import Reflux from 'reflux';

const SingleNodeActions = Reflux.createActions({
  'get': {asyncResult: true},
});

export default SingleNodeActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/nodes/SingleNodeActions.js